import React, { useState } from 'react';
import { IconUpload, IconClose } from './icons';

function Upload({ onFilesSelected }) {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);

  const ALLOWED_TYPES = [
    'image/jpeg', 'image/png', 'application/pdf', 'video/mp4',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'audio/mpeg', 'audio/wav', 'text/plain',
  ];
  const MAX_FILE_SIZE = 25 * 1024 * 1024; // precisa bater com MAX_EVIDENCIA_MB no backend

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    setError(null);

    const validFiles = selectedFiles.filter(file => {
      if (!ALLOWED_TYPES.includes(file.type)) {
        setError(`Tipo de arquivo não permitido: ${file.name}`);
        return false;
      }
      if (file.size > MAX_FILE_SIZE) {
        setError(`Arquivo muito grande: ${file.name}`);
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {
      setFiles(validFiles);
      onFilesSelected(validFiles);
    }
  };

  const removeFile = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
    onFilesSelected(newFiles);
  };

  return (
    <div className="upload-container">
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        accept=".jpg,.jpeg,.png,.pdf,.mp4,.docx,.xlsx,.mp3,.wav,.txt"
        id="file-input"
        className="file-input"
      />
      <label htmlFor="file-input" className="file-label">
        <IconUpload />
        Selecionar arquivos
      </label>

      {error && <p className="error-message">{error}</p>}

      {files.length > 0 && (
        <div className="file-list">
          <h4>Arquivos selecionados</h4>
          {files.map((file, index) => (
            <div key={index} className="file-item">
              <span>{file.name}</span>
              <button
                type="button"
                onClick={() => removeFile(index)}
                className="btn-remove"
                aria-label={`Remover ${file.name}`}
              >
                <IconClose />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Upload;
